import CancelTime from '@assets/icons/cancel-time.svg'
import { Icon } from './Icon'

export const CancelTimeIcon = Icon(CancelTime)
